import React, { useEffect, useState } from "react";
import TextField from "calcite-react/TextField";

import "./SaveNShare.scss";
import Button from "calcite-react/Button/Button";
import { environment } from "../../../constants/environment";
import { IconButton, DialogTitle, makeStyles, Dialog, DialogContent } from "@material-ui/core";
import XIcon from "calcite-ui-icons-react/XIcon";

function SaveNShare(props) {
  const { open, setOpen } = props;
  const [url, setURL] = useState("");

  const handleCopyToClipboard = () => {
    const copyText = document.querySelector("#saveURL");
    copyText.select();
    document.execCommand("copy");
  };

  useEffect(() => {
    const fetchShortURL = async () => {
      const requestHeaders = {
        "Content-Type": "application/json",
        apikey: environment.rebrandlyAPIKey,
      };

      const linkRequest = {
        destination: window.location.href,
      };

      let data;
      try {
        const response = await fetch(`https://api.rebrandly.com/v1/links`, {
          method: "POST",
          headers: requestHeaders,
          body: JSON.stringify(linkRequest),
        });
        data = await response.json();
        if (data.shortUrl) {
          setURL(data.shortUrl);
        } else {
          setURL(window.location.href);
        }
      } catch (e) {
        setURL(window.location.href);
      }
    };
    if (open) {
      fetchShortURL();
    }
  }, [open]);

  const onClose = () => {
    setOpen(false);
  }

  const useStyles = makeStyles({
    title: {
      fontFamily: 'Lato',
      fontSize: '1.25rem',
      color: '#031D44',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'rgb(234, 234, 234)',
    },
    subtitle: {
      fontFamily: 'Lato',
      color: '#031D44',
      fontSize: '16px',
    },
    close: {
      position: 'absolute',
      color: '#031D44',
      top: '4px',
      right: '8px',
    },
    paper: {
      height: 'fit-content',
      width: '100%',
    },
    footer: {
      paddingBottom: '24px',
      paddingTop: '24px',
    }
  });

  const classes = useStyles();

  return (
    <div className="saveNShare">
      <Dialog
        classes={{paper: classes.paper}}
        open={open}
        className={`saveNShare-wrapper`}
        onClose={onClose}
      >
        <DialogTitle className={classes.title} disableTypography>
          Save And Share
        </DialogTitle>
        <IconButton
          className={classes.close}
          aria-label="close"
          onClick={onClose}
          type="button"
          component="span">
          <XIcon />
        </IconButton>
        <DialogContent className={classes.footer}>
          <header className={classes.subtitle}>Permalink</header>
          <TextField
            id="saveURL"
            fullWidth={true}
            value={url}
            rightAdornment={
              <Button 
                style={{
                  fontFamily: 'Lato',
                  backgroundColor: '#035bd8',
                }} 
                onClick={handleCopyToClipboard}>Copy</Button>}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SaveNShare;
